import React from 'react';

import {
  CostModelFormCreate,
  CostModelFormEdit,
} from 'scenes/Campaigns/ParentCampaigns/components/CostModelForm';
import {
  useLoadParentCampaign,
  useEditParentCampaign,
  useCreateParentCampaign,
} from 'scenes/Campaigns/ParentCampaigns/data';
import MultiCampaignsForm from 'scenes/Campaigns/GGCampaigns/components/CampaignForm/MultiCampaignsForm';
import { withCampaignCreateChaining } from 'scenes/Campaigns/GGCampaigns/components/CampaignForm';

import ParentCampaignForm from './ParentCampaignForm';
import { duplicateCampaign } from './schema';

export const ParentCampaignFormEdit = ({
  onClose,
  id,
  name,
  onExited,
  open,
  onChange,
  onSubmit,
}) => {
  const [editCampaign, { isLoading: loading }] = useEditParentCampaign();
  const { data, isLoading } = useLoadParentCampaign({ id });

  const handleSubmit = (values) =>
    editCampaign({ id, ...values }).then(onSubmit);

  return (
    <ParentCampaignForm
      id={id}
      title={'Edit Parent Campaign'}
      name={name}
      loading={isLoading || loading}
      active={!!data}
      onSubmit={handleSubmit}
      onClose={onClose}
      initialValues={data}
      CostModelFormCreate={CostModelFormCreate}
      CostModelFormEdit={CostModelFormEdit}
      onExited={onExited}
      open={open}
      onChange={onChange}
    />
  );
};

export const ParentCampaignFormDuplicate = ({
  onSubmit,
  onClose,
  id,
  onExited,
  open,
}) => {
  const [createCampaign, { isLoading: loading }] = useCreateParentCampaign();
  const { data, isLoading } = useLoadParentCampaign({ id });

  const handleSubmit = (values) => createCampaign(values).then(onSubmit);

  return (
    <MultiCampaignsForm
      title={'Add Campaign'}
      loading={isLoading || loading}
      active={!!data}
      onSubmit={handleSubmit}
      onClose={onClose}
      initialValues={data && duplicateCampaign(data)}
      CostModelFormCreate={CostModelFormCreate}
      CostModelFormEdit={CostModelFormCreate}
      removableCostModels={true}
      onExited={onExited}
      open={open}
    />
  );
};

export const ParentCampaignFormDuplicateWithChaining =
  withCampaignCreateChaining(ParentCampaignFormDuplicate);
